module.exports = __webpack_public_path__ + "img/linghang.52f6b451.png";